import { jsx as _jsx } from "react/jsx-runtime";
import { Link as _Link } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
const Link = _Link;
/**
 *
 * A Link for use when we need react-router
 */

const CUIRouterLink = /*#__PURE__*/forwardRef((args, ref) => {
  return /*#__PURE__*/_jsx(Link, Object.assign({
    as: RouterLink
  }, args, {
    ref: ref
  }));
});
export default CUIRouterLink;